import Loadable from 'react-loadable';
import LoadingComponent from '../../common/loader/index';

export default [
    {
        path: '/special-request',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/SpecialRequest'),
            loading: LoadingComponent
        })
    }
];
